import React, {Component} from 'react';
import { Route, Switch } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ConfigActions } from './redux/actions';
import "isomorphic-fetch";
import NoticeGenerator from './components/NoticeGenerator';
import Header from './components/Header';
import ROUTES from './constants/RouteConstants';
import { WebToolOne } from './components/WebtoolOne';
import Error404 from './components/ErrorBoundary/ErrorPages/Error404';
import { Validator } from './components/Validator';
import { RentIncreaseCalculator } from './components/RentIncreaseCalculator';

class App extends Component {
  constructor(props) {
    super(props);
    fetch(this.getJSONFilePath()).then((res) => {
      if(!res.ok) throw new Error("HTTP error " + res.status);
      return res.json();
    }).then((json) => {
      this.props.addCpiConfig(json);
    }).catch((err) => {
      throw new Error("Incorrect CPI config" + err);
    });
  }

  getJSONFilePath() {
    let filePath = `${process.env.PUBLIC_URL}/cpi_config.json`;
    // Append a timestamp query param to json files so they are not cached, by default
    filePath += `${filePath.indexOf('?') === -1 ? '?' : '&'}t=${(new Date()).getTime()}`;
    return filePath;
  }
  
  render() {
    return (
      <>
        <Header />
        <Switch>
          <Route exact path={ROUTES.BASE} component={NoticeGenerator} />{/*default route handler*/}
          <Route replace path={ROUTES.EXPLORER} component={WebToolOne} />
          <Route exact replace path={ROUTES.EXPLORER_STEP1} component={WebToolOne} />
          <Route exact replace path={ROUTES.EXPLORER_STEP2} component={WebToolOne} />

          <Route replace path={ROUTES.NOTICEGEN} component={NoticeGenerator} />
          <Route exact replace path={ROUTES.NOTICEGEN_STEP1} component={NoticeGenerator} />
          <Route exact replace path={ROUTES.NOTICEGEN_STEP2} component={NoticeGenerator} />
          <Route exact replace path={ROUTES.LANDLORD_VALIDATOR} component={Validator} />
          <Route exact replace path={ROUTES.TENANT_VALIDATOR} component={Validator} />
          <Route exact replace path={ROUTES.RENT_INCREASE_CALCULATOR} component={RentIncreaseCalculator} />
          <Route component={Error404} />
          {/* Catch all "*??" */}
        </Switch>
      </>
    );
  }
};

const mapDispatchToProps = (dispatch) =>
bindActionCreators(
  {
    addCpiConfig: ConfigActions.addCpiConfig
  },
  dispatch
)

export default connect(null, mapDispatchToProps)(App);
